import React from 'react';
import { connect } from 'react-redux';

import { ContentSet } from 'components/Shared/Scaffolding';
import Panel, { PanelTitle } from 'components/Shared/Panel';
import InfoWindowForm from 'components/InfoWindowSettings/InfoWindowForm';
import { clearActiveMarker } from 'modules/navigation/activeMarker';
import { SCAFFOLDING } from 'theme';
import withCancel from 'components/Shared/PanelCancel';

class InfoWindowPanel extends React.Component {
    handleClose = () => {
        const { clearActiveMarker, onClose } = this.props;
        clearActiveMarker();
        onClose();
    };

    render() {
        const { open, onCancel } = this.props;
        return (
            <Panel open={open} onClose={onCancel}>
                <ContentSet spacing={SCAFFOLDING.GUTTER} padding={SCAFFOLDING.GUTTER}>
                    <PanelTitle>Popup</PanelTitle>
                    {open && <InfoWindowForm onClose={this.handleClose} onCancel={onCancel} />}
                </ContentSet>
            </Panel>
        );
    }
}

const mapDispatchToProps = {
    clearActiveMarker,
};

export default connect(
    null,
    mapDispatchToProps
)(
    withCancel({
        form: 'info-window',
        dispatches: [clearActiveMarker()],
    })(InfoWindowPanel)
);
